"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const pricingData = [{
  id: 1,
  service: "Einfacher Arbeitsplatz mit Monitor und\nDockingstation",
  daily: "50€",
  monthly: "250€",
  setup: "0€",
  availability: "Übergabe: Mo-Fr, 8-16.30 Uhr/Nutzung 24/7"
}, {
  id: 2,
  service: "Einzelbüro mit 1 Arbeitsplatz abschließbar",
  daily: "100€",
  monthly: "500€",
  setup: "0€",
  availability: "Übergabe: Mo-Fr, 8-16.30 Uhr/Nutzung 24/7"
}, {
  id: 3,
  service: "Büro mit 4 Arbeitsplätzen, abschließbar + direkter Küchenzugang",
  daily: "200€",
  monthly: "1000€",
  setup: "99€",
  availability: "Übergabe: Mo-Fr, 8-16.30 Uhr/Nutzung 24/7"
}, {
  id: 4,
  service: "Meetingraum only",
  daily: "40€",
  monthly: "-",
  setup: "149€",
  availability: "Übergabe: Mo-Fr, 8-16.30 Uhr/Nutzung 24/7"
}, {
  id: 5,
  service: "E-Ladesäule\xA0",
  daily: "0,40€/kWh",
  monthly: "-",
  setup: "0€",
  availability: "24/7"
}, {
  id: 7,
  service: "Briefkasten Mindestmietdauer (6 Monate)\xA0",
  daily: "-",
  monthly: "20€",
  setup: "49€",
  availability: "24/7"
}];
export default function PricesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="preise-im-überblick" className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {/* Header - Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 md:mb-20">
        <div>
          <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Preise</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
            <span className="text-[#141414]">Preise im</span><br />
            <span className="text-[#888888]">Überblick.</span>
          </h2>
        </div>
        <div className="flex items-end">
          <p className="text-lg text-[#555555] leading-relaxed">Übergabe: Mo–Fr, 8–16.30 Uhr. Nutzung: 24/7.&nbsp;</p>
        </div>
      </div>

      {/* Table */}
      <div className="rounded-[1rem] overflow-hidden bg-white/60 backdrop-blur-sm">
        {/* Desktop Table */}
        <table className="w-full hidden sm:table">
          <thead>
            <tr className="border-b border-[#141414]/10">
              <th className="text-left text-sm font-semibold uppercase tracking-widest text-[#888888] py-6 px-8">Service</th>
              <th className="text-left text-sm font-semibold uppercase tracking-widest text-[#888888] py-6 px-8">Tag</th>
              <th className="text-left text-sm font-semibold uppercase tracking-widest text-[#888888] py-6 px-8">Monat</th>
            </tr>
          </thead>
          <tbody>
            {pricingData.map((item, i) => <tr key={item.id} data-index={i} className="border-b border-[#141414]/5 last:border-0 transition-colors duration-200 hover:bg-white">
                <td className="text-base font-semibold text-[#141414] py-5 px-8">{item.service}</td>
                <td className="text-base text-[#555555] py-5 px-8">{item.daily}</td>
                <td className="text-base text-[#555555] py-5 px-8">{item.monthly}</td>
              </tr>)}
          </tbody>
        </table>

        {/* Mobile Cards */}
        <div className="sm:hidden divide-y divide-[#141414]/5">
          {pricingData.map((item, i) => <div key={item.id} data-index={i} className="p-6">
              <h3 className="text-base font-semibold text-[#141414] mb-3">{item.service}</h3>
              <div className="flex justify-between gap-4">
                <div>
                  <span className="text-xs font-semibold uppercase tracking-widest text-[#888888] block mb-1">Tag</span>
                  <span className="text-base text-[#555555]">{item.daily}</span>
                </div>
                <div>
                  <span className="text-xs font-semibold uppercase tracking-widest text-[#888888] block mb-1">Monat</span>
                  <span className="text-base text-[#555555]">{item.monthly}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {/* Button */}
      <div className="mt-16">
        <Link to="/kontakt">
          <Button size="lg" className="h-14 rounded-full bg-[#FF6F61] text-base font-semibold text-white shadow-lg transition-all hover:bg-[#FF6F61]/90 hover:shadow-xl hover:-translate-y-0.5" style={{
              paddingLeft: '80px',
              paddingRight: '80px'
            }}>
            Jetzt anfragen
          </Button>
        </Link>
      </div>
    </div>
  </div>
</section>;
}